<template>
 <div class="group-news">

   <scroll-menu>
     <!-- grey color D9D9D9-->
      <scroll-button color="#666666" v-if='showFeed("parents")'  :to="'/group/'+id+'/news/parents/'" title="language.group_news_parents"></scroll-button>
      <scroll-button  color="#666666" v-if='showFeed("group")'  :to="'/group/'+id+'/news/group/'" title="language.group_news_group"></scroll-button>
      <scroll-button  color="#666666" v-if='showFeed("approval")'  :to="'/group/'+id+'/news/approval/'" title="language.group_news_validate"></scroll-button>
      <scroll-button  color="#666666" v-if='showFeed("mylist")'  :to="'/group/'+id+'/news/mylist/'" title="language.group_news_my_messages"></scroll-button>
    </scroll-menu>

    <scroll-page :pull-reload="true">
    

    <page-padding v-if="computeUserAccess">
      <button-action :to="'/group/'+this.id+'/news/'+news_id+'/add_item/'" title="language.add_news_item" ></button-action>
   </page-padding>


    <list-news :key="updateKey" :news_id="news_id" :feed="feed" />
    
  </scroll-page>

</div>
</template>

<script>

import { mapState } from 'vuex';
import ScrollMenu from '../components/scrollMenu/ScrollMenu.vue';
import ScrollButton from '../components/scrollMenu/ScrollButton.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding';
import ListNews from '../components/news/ListNews';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'group-news-page',
  data:function(){
    return{
      id:this.$route.params.id, /* group id */
      feed:this.$route.params.feed,
      news_id:undefined,
      updateKey:0,
    }
  },
  
  computed:{
     ...mapState([
       'groups','appSettings','loaded','group'
       ]),
       computeUserAccess(){
         if(!this.group.authorized){
           return false;
          }
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    ScrollMenu,
    ScrollButton,
    ButtonAction,
    PagePadding,
    ListNews,
    ScrollPage,
  },
  methods:{
    initFeed(){
      
      this.feed=this.$route.params.feed;

      // get group id
      this.id=this.$route.params.id;
      // get news id from group
      this.news_id=this.group.news_id;

      if(this.feed=="init"){
         
      // redirect for each user
      
      switch(this.appSettings.user_level){
        case USER_LEVEL.PARENT:
          
          this.$router.push('/group/'+this.id+'/news/parents/')
        break;
        case USER_LEVEL.STUDENT:
          
          this.$router.push('/group/'+this.id+'/news/group/')
        break;
        case USER_LEVEL.ADMIN:
          
          this.$router.push('/group/'+this.id+'/news/parents/')
        break;
        case USER_LEVEL.TEACHER:
          
          this.$router.push('/group/'+this.id+'/news/parents/')
        break;
      }
   
   }
   
    },
   
    showFeed(type){
      switch(type){
        case "parents":
          if (this.appSettings.user_level==USER_LEVEL.PARENT) {return false;} /* because parents have only this button and it cant be clicked, better remove it */
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
        break;
        case "group":
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.STUDENT) {return true;}
        break;
        case "approval":
          if(!this.group.authorized){return false;}
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
        break;
        case "mylist":
          if(!this.group.authorized){return false;}
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.STUDENT) {return true;}
        break;
      }

      return false;
    }
  },// methods{}
  beforeDestroy(){
    
  },
  mounted(){
   
    this.updateKey=new Date().getTime();

    // init the feed
    this.initFeed();
    
  },
  
  watch:{
    '$route.params.feed': {
        handler: function(feed) {
           this.feed=feed;
           this.updateKey=new Date().getTime();
           this.initFeed();
        }
      }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.group-news{
  width:100%;
  display:flex;
  flex:1;
  flex-direction: column;
}

</style>